'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _PDFIcon = _interopRequireDefault(require("Icons/PDFIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
class FileInput extends _react.Component {
  state = {
    id: ++app.form_index,
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const previews = props.data['__files-' + props.name];
    if (Array.isArray(previews)) return;
    props.onChange({
      e: null,
      previews: [],
      name: props.name,
      source: 'DidMount'
    });
    component.setState({
      loading: false
    });
  }
  removeFile = (e, preview_to_remove) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    let previews = props.data['__files-' + props.name] || [];
    app.emit({
      event: 'documentClick'
    });
    previews = previews.filter(preview => preview !== preview_to_remove);
    component.clearHTMLValue();
    props.onChange({
      e: null,
      previews: previews,
      name: props.name,
      source: 'native-remove'
    });
  };
  clearHTMLValue = () => {
    const component = this,
      props = this.props,
      state = this.state;
    (document.getElementById(state.id) || {}).value = '';
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const input_element = /*#__PURE__*/_react.default.createElement("input", {
      type: "file",
      className: "c-form-element__file",
      name: props.name,
      id: state.id,
      onChange: handleChange,
      multiple: props.multiple,
      accept: props.accept
    });
    if (props.hidden === true) return input_element;
    let class_name = props.className || 'c-form-element';
    let status = props.status[props.name] || {};
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-form-element__file-loader"
    }, /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['small', 'primary', 'bg-white']
    })) : undefined;
    const label = props.label ? /*#__PURE__*/_react.default.createElement("label", {
      className: "c-form-label c-form-label--file",
      htmlFor: state.id
    }, props.label) : undefined;
    let info, warning, error;
    if (status.info) {
      info = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label c-form-label--info"
      }, status.info);
      class_name += ' c-form-element--info';
    }
    if (status.warning) {
      warning = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label\r c-form-label--file c-form-label--warning"
      }, status.warning);
      class_name += ' c-form-element--warning';
    }
    if (status.error) {
      error = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-form-label\r c-form-label--file c-form-label--error"
      }, status.error);
      class_name += ' c-form-element--error';
    }
    const previews = (props.data['__files-' + props.name] || []).map(function (preview, index) {
      let filename = preview.filename || '';
      let extension = filename.slice(filename.lastIndexOf('.'), filename.length);
      filename = filename.slice(0, filename.indexOf(extension));
      const full_filename = filename + extension;

      // shorten filename if too long and add '...'
      if (filename.length > 20) {
        filename = filename.slice(0, 17) + '...';
      }
      filename += extension;
      let image;
      if (preview.image) {
        image = /*#__PURE__*/_react.default.createElement(_Image.default, {
          className: "c-file-thumbnail__preview",
          src: preview.image,
          title: full_filename,
          alt: full_filename
        });
      } else if (preview.pdf) {
        if (preview.url) {
          image = /*#__PURE__*/_react.default.createElement("a", {
            href: preview.url,
            target: "_blank",
            className: "c-file-thumbnail__link",
            type: "application/pdf"
          }, /*#__PURE__*/_react.default.createElement(_PDFIcon.default, {
            className: "c-file-thumbnail__icon"
          }));
        } else {
          image = /*#__PURE__*/_react.default.createElement(_PDFIcon.default, {
            className: "c-file-thumbnail__icon"
          });
        }
      } else if (preview.url) {
        image = /*#__PURE__*/_react.default.createElement("a", {
          href: preview.url,
          target: "_blank",
          className: "c-file-thumbnail__link"
        }, /*#__PURE__*/_react.default.createElement(_Image.default, {
          className: "c-file-thumbnail__preview",
          src: preview.url,
          title: full_filename,
          alt: full_filename
        }));
      }
      let output = /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail",
        key: index
      }, image, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__title",
        htmlFor: state.id
      }, filename), props['read-only'] !== true ? /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        title: "Enlever",
        className: "c-file-thumbnail__delete",
        onClick: function (e) {
          component.removeFile(e, preview);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "c-file-thumbnail__delete-icon"
      })) : undefined);
      return output;
    });
    let toggle = props['read-only'] !== true ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      htmlFor: state.id,
      component: "label",
      className: props['button-class']
    }, props.multiple === true ? props['add-label'] || 'Ajouter' : previews.length === 0 ? props['add-label'] || 'Ajouter' : props['edit-label'] || 'Modifier') : undefined;
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, label, info, warning, error, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-flex u-items-center u-flex-wrap"
    }, input_element, props.children, previews, toggle, loader));
    return output;
    function handleChange(e) {
      let new_files = e.target.files;
      e.preventDefault();
      if (props['read-only'] === true) return;
      if (new_files.length === 0) return;
      let previews = props.data['__files-' + props.name] || [];
      component.setState({
        loading: true
      });
      let files_count = new_files.length;
      if (props.multiple === false) {
        files_count = 1;
      }
      for (let i = 0; i < files_count; i++) {
        fileListener(new_files[i]);
      }
      function fileListener(file) {
        let reader = new FileReader();
        reader.onloadend = function () {
          let preview = {
            form_name: props.name,
            pdf: file.type === 'application/pdf',
            image: file.type.startsWith('image/') ? reader.result : undefined,
            filename: file.name,
            file: file,
            type: file.type
          };

          // Remove previous image if only one is allowed
          if (props.multiple === false) {
            previews = [];
          }
          previews.push(preview);
          if (--files_count === 0) {
            component.clearHTMLValue();
            props.onChange({
              e: e,
              previews: previews,
              name: props.name,
              source: 'native-add'
            });
            component.setState({
              loading: false
            });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  }
}
exports.default = FileInput;
FileInput.propTypes = {
  'read-only': _propTypes.default.bool,
  multiple: _propTypes.default.bool,
  hidden: _propTypes.default.bool,
  name: _propTypes.default.string.isRequired,
  'button-class': _propTypes.default.string,
  'edit-label': _propTypes.default.string,
  'add-label': _propTypes.default.string,
  className: _propTypes.default.string,
  accept: _propTypes.default.string,
  label: _propTypes.default.string,
  status: _propTypes.default.object.isRequired,
  data: _propTypes.default.object.isRequired,
  onChange: _propTypes.default.func
};
FileInput.defaultProps = {
  'read-only': false,
  multiple: false,
  hidden: false,
  accept: '.jpg, .jpeg, .png, .svg, .gif, .pdf'
};
